import React, { useContext } from "react";
import { WebsiteContext } from "../../context/AppContext";
import { motion } from "framer-motion";
import { FaStar } from "react-icons/fa";
import "../../styles/reviewCard.css";

const WriteReview = () => {
  const { isMobileView } = useContext(WebsiteContext);

  return (
    <div className="ratingSectionWrapper">
      <motion.div
        className={`ratingContainer ${isMobileView ? "mobile" : ""}`}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <div className="rateContent">
          <FaStar className="rateIcon" />
          <div className="rateText">
            Your opinion matters to us. Please let us know how we did and how we
            can make your next experience even better.
          </div>
        </div>

        <a
          href="https://g.page/r/Cdi61MKOmdrlEAI/review"
          target="_blank"
          rel="noopener noreferrer"
          className="rateBtn"
        >
          Rate Us
        </a>
      </motion.div>
    </div>
  );
};

export default WriteReview;
